import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import getBackendURL from 'util/backend-url'
import App from './App'
import * as serviceWorker from './serviceWorker'

const reactRoot = document.getElementById('root')
const searchPage = reactRoot.getAttribute('data-page')

window.BACKEND_URL = getBackendURL

ReactDOM.render(<App searchPage={searchPage} />, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
